import React, { Component } from 'react';


export class PageNotFound extends Component {
    static displayName = PageNotFound.name;

  render() {
    return (
        <div>

            {/*PageNotFound navbar starts here*/}
            <div class="container-fluid position-relative p-0">
                <div class="container-fluid bg-primary py-5 bg-header">
                    <div class="row py-5">
                        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
                            <h3 class="text-capitalize text-white animated zoomIn">page not found</h3>
                            <a class="h5 text-white">Home</a>
                            <i class="fa fa-chevron-right text-white px-2"></i>
                            <a class="h5 text-white">PageNotFound</a>
                        </div>
                    </div>
                </div>
            </div>
            {/*PageNotFound navbar ends here*/}

            {/*PageNotFound section starts here*/}
            <div class="container py-5">
                <div class="section-title text-center position-relative pb-3 mb-5 mx-auto">
                    <h5 class="fw-bold text-primary text-uppercase">the page you are looking for is not found</h5>
                    <h3 class="mb-0 text-uppercase fw-bold">please check your URL</h3>
                </div>
            </div>
            {/*PageNotFound section ends here*/}
      </div>
    );
  }
}
